export enum MarktypUndergrund {
  NA = 0,
  Berg = 1,
  Morän = 2,
  Lera = 3,
  Okänd = 4
}

export enum Grundlaggning {
  NA = 0,
  Platta = 1,
  Pålar = 2,
  Plintar = 3,
  Mur = 4,
  Okänd = 5
}

export enum Stommaterial {
  NA = 0,
  Stål = 1,
  Trä = 2,
  Betong = 3,
  Lättbetong = 4,
  Betonghålsten = 5,
  Okänd = 6
}

export enum Bjalklagsmaterial {
  NA = 0,
  Stål = 1,
  Trä = 2,
  Betong = 3,
  Okänd = 4
}

export enum Fasadmaterial {
  NA = 0,
  Plåt = 1,
  Trä = 2,
  Puts = 3, 
  Betong = 4,
  Tegel = 5,
  Kalksandsten = 6,
  Plattor = 7,
  Okänd = 8
}

export enum Brunn {
  NA = 0,
  Ja = 1,
  Nej = 2,
  Okänd = 3
}

export enum MuradeEldstader {
  NA = 0,
  Ja = 1,
  Nej = 2,
  Okänd = 3
}

export enum KansligUtrustning {
  NA = 0,
  SeAnmärkningsfält = 1
}

export enum DimmensionerandeByggnadsmaterial {
  NA = 0,
  BetongStålTrä = 1,
  LättklinkerTegel = 2,
  LättbetongPutsStuckatur = 3,
  KakelugnKänsligaFogarKalksandsten = 4,
  Okänd = 5
}

export enum Ovrigt {
  NA = 0,
  SeAnmärkningsfält = 1
}

export enum Phase {
  FB = 0,
  MB = 1,
  EB = 2
}

export interface DocumentBase {
  id: string;
  foreignId?: string;
  documentType?: string;
  status?: string;
  createdDate: string;
  name?: string;
  signF?: string;
  signM?: string;
  signE?: string;
  litteria?: string;
  address?: string;
  number?: string;
  rise?: string;
  plan?: string;
  evhgh?: string;
  remarks?: string;
  createdBy?: string;
  image?: string;
  userId?: string;
  stairwell: boolean;
  fristHouse: boolean;
  gen_KV: boolean;
  local: boolean;
  projectId: string;
  projectNumber: number;
  parentId: string;
  isPdfDone?: boolean;
  isDelete: boolean;
  marktypUndergrund: MarktypUndergrund;
  grundlaggning: Grundlaggning;
  stommaterial: Stommaterial;
  bjalklagsmaterial: Bjalklagsmaterial;
  fasadmaterial: Fasadmaterial;
  brunn: Brunn;
  muradeEldstader: MuradeEldstader;
  kansligUtrustning?: KansligUtrustning;
  dimmensionerandeByggnadsmaterial: DimmensionerandeByggnadsmaterial;
  ovrigt?: Ovrigt;
  phase: Phase;
  isSkadebesiktning: boolean;
}

export interface DocumentDetails extends DocumentBase {}

export interface DocumentDetailsDTO extends DocumentBase {
  imageBase64?: string;
}

export interface DocumentHierarchyDTO extends DocumentBase {
  documentChildren: DocumentDetails[];
}

export interface DocumentDetailPageProps {
  projectId?: string;
}